
<div class='set-position' mat-dialog-content>
  <ng-container *ngIf="selectedDays !== 'all days' else matDateRangePicker">
    <div class="calendar-container">
      <mat-calendar #calendar (selectedChange)="select($event)" [dateClass]="isSelected" [dateFilter]="dateFilter"></mat-calendar>
      
      <!-- ✅ Action Buttons Below Calendar -->
      <div class="calendar-actions">
        <button mat-raised-button color="primary" (click)="applyDate(false)">Apply</button>
        <button mat-button class="du-transparent-btn" (click)="cancelSelection()">Cancel</button>
      </div>
    </div>
  </ng-container>

    <ng-template #matDateRangePicker>
        <mat-form-field class="form-control hideContent">
            <!-- ✅ Link the date range picker to an input -->
            <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [dateFilter]="dateRangeFilter">
              <input matStartDate formControlName="from_date" placeholder="Start date" hidden>
              <input matEndDate formControlName="to_date" placeholder="End date" hidden>
            </mat-date-range-input>
            
            <!-- ✅ Ensure there's a toggle button, even if hidden -->
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            
            <!-- ✅ Define the Date Range Picker -->
            <mat-date-range-picker #picker>
              <mat-date-range-picker-actions class="calendar-actions">
                <button mat-raised-button color="primary" matDateRangePickerApply (click)="applyDate(true)">Apply</button>
                <button mat-button matDateRangePickerCancel class="du-transparent-btn" (click)="cancelSelection()">Cancel</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
        </mat-form-field>
    </ng-template>
</div>

  
  